import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const deleteRestrictionRuleSlice = createApi(`DeleteRestrictionRuleSlice`,"DELETE");

const DeleteRestrictionRuleSlice = createSlice({
  name: 'DeleteRestrictionRuleSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteRestrictionRuleSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteRestrictionRuleSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteRestrictionRuleSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default DeleteRestrictionRuleSlice.reducer;